import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import HoldingTankTable from '../../components/HoldingTank/HoldingTankTable'
import { ApiHook } from '../../hooks/apiHook';
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { useQuery, useQueryClient } from '@tanstack/react-query';
function HoldingTank() {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [fatherId, setfatherId] = useState()
    const { t } = useTranslation()
    const holdingTankUsers = ApiHook.CallholdingTankusers(currentPage, itemsPerPage)
    const [selectedPlacement, setselectedPlacement] = useState()
    const [previousSelectedIndex, setPreviousSelectedIndex] = useState(null);
    const [selectedIndex, setselectedIndex] = useState()
    const [selectedPosition, setselectedPosition] = useState()
    const [placementErr, setplacementErr] = useState()
    const [positionErr, setpositionErr] = useState()
    const placeUser = ApiHook.CallplaceHoldingTankusers()
    const checkAvailiablePosition = ApiHook.CallcheckAvailiablePosition(fatherId)
    const queryClient = useQueryClient();

    const user = useSelector(
        (state) => state.dashboard?.appLayout?.user
    );
    console.log("==userffyh==", user)
    const placementChangeHandler = (placementUser, rowIndex) => {
        setfatherId(placementUser.value)
        setselectedPlacement((prevState) => ({
            ...prevState,
            [rowIndex]: placementUser,
        }));
        setselectedIndex(rowIndex)
        if (selectedPosition) {
            setselectedPosition(null)
        }
        queryClient.invalidateQueries(['availiable-position']);
    };
    const positionChangeHandler = (position, rowIndex) => {
        setselectedPosition(prevState => ({
            ...prevState,
            [rowIndex]: position,
        }));
        setselectedIndex(rowIndex);
    };
    console.log("====position", selectedPlacement)

    const placeHoldingTankusers = async (userId) => {
        if (!selectedPlacement) {
            return toast.error(t('selecte_father'))
        } else if (!selectedPosition) {
            return toast.error(t('select_position'))
        }
        // if (selectedPlacement) {
        //     if (!selectedPlacement[selectedIndex]) {
        //         return setplacementErr({
        //             [selectedIndex]: t('choose_placemnt')
        //         })
        //     }
        // }
        // if (selectedPosition) {
        //     if (!selectedPosition[selectedIndex]) {
        //         return setpositionErr({
        //             [selectedIndex]: t('choose_position')
        //         })
        //     }
        // }



        let approveData = {
            [userId]: {
                position: selectedPosition[selectedIndex]?.value,
                father: selectedPlacement[selectedIndex]?.value,
            }
        };
        const response = await placeUser.mutateAsync(approveData)
        if (response.status) {
            toast.success(t('user_placed_suucessfully'))
            setselectedPlacement(null)
            setselectedPosition(null)
            await holdingTankUsers.refetch()
        }
    }
    console.log("==checkAvailiablePosition==", checkAvailiablePosition?.isFetching)
    console.log("==holdingTankUsers", holdingTankUsers?.data)
    console.log("==placementErrr=gt=", placementErr)
    return (
        <>
            <div className="page_head_top">{t("holdingTank")}</div>

            <HoldingTankTable
                data={holdingTankUsers?.data?.data}
                type={"holding-tank-report"}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                placementChangeHandler={placementChangeHandler}
                selectedPlacement={selectedPlacement}
                positionLoader={checkAvailiablePosition?.isFetching}
                availiablePositions={checkAvailiablePosition?.data}
                selectedRowIndex={selectedIndex}
                positionChangeHandler={positionChangeHandler}
                selectedPosition={selectedPosition}
                placeHoldingTankusers={placeHoldingTankusers}
                placeUserApiLoading={placeUser.isLoading}
                placementErr={placementErr}
                positionErr={positionErr}
                user={user}
            />
        </>
    )
}

export default HoldingTank